import type { TranslationKey, Language } from './types';
import { resolve } from './registry';

/**
 * Translate a key to its platform- and language-specific value.
 *
 * @param key - Dot-notation translation key (e.g. 'home.hero.headerText')
 * @param options - Optional language override
 * @returns The resolved translation string
 */
export function t(key: TranslationKey, options?: { lang?: Language }): string {
  return resolve(key, options?.lang);
}
